export { default } from './RegAndEditPlayer';